import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

function BookingStatus() {

    const { ref_no } = useParams();
    const navigate = useNavigate();

    const [booking, setBooking] = useState(null);
    const [loading, setLoading] = useState(true);

    // =========================
    // FETCH BOOKING STATUS
    // =========================

    useEffect(() => {

        fetchBookingStatus();

    }, []);

    const fetchBookingStatus = async () => {

        try {

            const res = await fetch(
                `https://orisoftpl.com/backend/api/frontend/booking/payment/${ref_no}`
            );

            const data = await res.json();

            if (!res.ok) {

                alert(data.message);

                navigate('/');

                return;
            }

            setBooking(data.booking);

        } catch (error) {

            console.log(error);

        } finally {

            setLoading(false);
        }
    };

    // =========================
    // DATE FORMATTER
    // =========================

    const formatDate = (date) => {

        if (!date) return '-';

        return new Date(date).toLocaleDateString(
            'en-IN',
            {
                day: '2-digit',
                month: 'long',
                year: 'numeric',
            }
        );
    };

    // =========================
    // PRINT RECEIPT
    // =========================

    const printReceipt = () => {

        const receiptWindow = window.open(
            '',
            '',
            'width=900,height=800'
        );

        receiptWindow.document.write(`

        <html>

            <head>

                <title>
                    Mandap Booking Receipt
                </title>

                <style>

                    *{
                        margin:0;
                        padding:0;
                        box-sizing:border-box;
                    }

                    body{
                        font-family:Arial,sans-serif;
                        background:#f3f4f6;
                        padding:10px;
                        color:#333;
                    }

                    .receipt{

                        max-width:850px;
                        margin:auto;
                        background:white;
                        border-radius:20px;
                        overflow:hidden;
                        box-shadow:0 10px 30px rgba(0,0,0,0.1);
                        border:1px solid #ddd;
                    }

                    .header{

                        background:linear-gradient(
                            135deg,
                            #2563eb,
                            #1e3a8a
                        );

                        color:white;
                        padding:20px;
                        text-align:center;
                    }

                    .header h1{
                        font-size:26px;
                        margin-bottom:10px;
                    }

                    .header p{
                        opacity:0.9;
                        font-size:16px;
                    }

                    .success{

                        width:60px;
                        height:60px;
                        border-radius:50%;
                        background:white;
                        color:#16a34a;
                        font-size:34px;
                        display:flex;
                        align-items:center;
                        justify-content:center;
                        margin:0 auto 20px;
                        font-weight:bold;
                    }

                    .body{
                        padding:40px;
                    }

                    .section-title{
                        font-size:24px;
                        font-weight:bold;
                        margin-bottom:20px;
                        color:#111827;
                    }

                    .grid{
                        display:grid;
                        grid-template-columns:1fr 1fr;
                        gap:20px;
                    }

                    .card{

                        border:1px solid #e5e7eb;
                        border-radius:16px;
                        padding:20px;
                        background:#f9fafb;
                    }

                    .label{
                        font-size:13px;
                        color:#6b7280;
                        margin-bottom:8px;
                    }

                    .value{
                        font-size:20px;
                        font-weight:bold;
                        color:#111827;
                    }

                    table{
                        width:100%;
                        border-collapse:collapse;
                        margin-top:20px;
                    }

                    table td{

                        border:1px solid #e5e7eb;
                        padding:16px;
                        font-size:15px;
                    }

                    table tr:nth-child(even){
                        background:#f9fafb;
                    }

                    .left{
                        font-weight:bold;
                        width:35%;
                    }

                    .badge{

                        display:inline-block;
                        padding:8px 16px;
                        border-radius:30px;
                        font-size:14px;
                        font-weight:bold;
                    }

                    .success-badge{
                        background:#dcfce7;
                        color:#166534;
                    }

                    .pending-badge{
                        background:#fef3c7;
                        color:#92400e;
                    }

                    .amount{

                        font-size:28px;
                        color:#16a34a;
                        font-weight:bold;
                    }

                    .footer{

                        margin-top:40px;
                        text-align:center;
                        color:#6b7280;
                        font-size:14px;
                    }

                    .note{

                        margin-top:30px;
                        background:#eff6ff;
                        border:1px solid #bfdbfe;
                        padding:20px;
                        border-radius:16px;
                        color:#1d4ed8;
                    }

                    @media print {

                        body{
                            background:white;
                            padding:0;
                        }

                        .receipt{
                            box-shadow:none;
                            border:none;
                        }
                            @page{
                            size:auto;
                            margin:8mm;
                        }
                    }

                </style>

            </head>

            <body>

                <div class="receipt">

                    <div class="header">

                        <div class="success">
                            ✓
                        </div>

                        <h1>
                            Mandap Booking Receipt
                        </h1>

                        <p>
                            Payment Successfully Completed
                        </p>

                    </div>

                    <div class="body">

                        <div class="grid">

                            <div class="card">

                                <div class="label">
                                    Booking Reference
                                </div>

                                <div class="value">
                                    ${booking?.booking_ref}
                                </div>

                            </div>

                            <div class="card">

                                <div class="label">
                                    Amount Paid
                                </div>

                                <div class="amount">
                                    ₹ ${booking?.price}
                                </div>

                            </div>

                        </div>

                        <div style="margin-top:40px;">

                            <div class="section-title">
                                Booking Details
                            </div>

                            <table>

                                <tr>
                                    <td class="left">
                                        Customer Name
                                    </td>

                                    <td>
                                        ${booking?.name}
                                    </td>
                                </tr>

                                <tr>
                                    <td class="left">
                                        Mobile Number
                                    </td>

                                    <td>
                                        ${booking?.mobile}
                                    </td>
                                </tr>

                                <tr>
                                    <td class="left">
                                        Mandap
                                    </td>

                                    <td>
                                        ${booking?.mandap?.name}
                                    </td>
                                </tr>

                                <tr>
                                    <td class="left">
                                        Purpose
                                    </td>

                                    <td>
                                        ${booking?.purpose_other
                ? booking?.purpose_other
                : booking?.purpose?.name || '-'
            }
                                    </td>
                                </tr>

                                <tr>
                                    <td class="left">
                                        From Date
                                    </td>

                                    <td>
                                        ${formatDate(booking?.from_date)}
                                    </td>
                                </tr>

                                <tr>
                                    <td class="left">
                                        To Date
                                    </td>

                                    <td>
                                        ${formatDate(booking?.to_date)}
                                    </td>
                                </tr>

                                <tr>
                                    <td class="left">
                                        Payment Status
                                    </td>

                                    <td>

                                        <span class="badge success-badge">
                                            ${booking?.payment_label}
                                        </span>

                                    </td>
                                </tr>

                                <tr>
                                    <td class="left">
                                        Booking Status
                                    </td>

                                    <td>

                                        <span class="badge pending-badge">
                                            ${booking?.status_label}
                                        </span>

                                    </td>
                                </tr>

                            </table>

                        </div>

                        <div class="note">

                            <strong>
                                Important:
                            </strong>

                            Your booking is currently pending admin approval.
                            Please keep this receipt safe for future reference.

                        </div>

                        <div class="footer">

                            Thank you for booking with us.<br>

                            Generated on:
                            ${new Date().toLocaleString()}

                        </div>

                    </div>

                </div>

            </body>

        </html>

        `);

        receiptWindow.document.close();

        receiptWindow.focus();

        setTimeout(() => {

            receiptWindow.print();

        }, 500);
    };

    // =========================
    // LOADING
    // =========================

    if (loading) {

        return (
            <div className='min-h-screen flex items-center justify-center text-2xl font-bold'>
                Loading...
            </div>
        );
    }

    return (

        <div className='min-h-screen bg-gray-100 py-10 px-4'>

            <div className='max-w-4xl mx-auto'>

                {/* SUCCESS CARD */}
                <div className='bg-white rounded-3xl shadow-2xl overflow-hidden'>

                    {/* HEADER */}
                    <div className='bg-gradient-to-r from-green-500 to-emerald-700 text-white p-10 text-center'>

                        <div className='w-24 h-24 rounded-full bg-white text-green-600 flex items-center justify-center text-5xl mx-auto shadow-lg'>
                            ✓
                        </div>

                        <h2 className='text-4xl font-bold mt-6'>
                            Payment Successful
                        </h2>

                        <p className='mt-3 text-lg opacity-90'>
                            Your booking request has been submitted successfully.
                        </p>
                    </div>

                    {/* BODY */}
                    <div className='p-8 md:p-10'>

                        {/* STATUS */}
                        <div className='grid grid-cols-1 md:grid-cols-2 gap-6'>

                            <div className='bg-gray-50 border rounded-2xl p-6'>

                                <p className='text-sm text-gray-500'>
                                    Booking Reference
                                </p>

                                <h3 className='text-2xl font-bold text-gray-800 mt-2'>
                                    {booking?.booking_ref}
                                </h3>

                            </div>

                            <div className='bg-gray-50 border rounded-2xl p-6'>

                                <p className='text-sm text-gray-500'>
                                    Payment Status
                                </p>

                                <div className='mt-3 inline-flex px-4 py-2 rounded-full bg-green-100 text-green-700 font-semibold'>
                                    {booking?.payment_label}
                                </div>

                            </div>

                            <div className='bg-gray-50 border rounded-2xl p-6'>

                                <p className='text-sm text-gray-500'>
                                    Booking Status
                                </p>

                                <div className='mt-3 inline-flex px-4 py-2 rounded-full bg-yellow-100 text-yellow-700 font-semibold'>
                                    {booking?.status_label}
                                </div>

                            </div>

                            <div className='bg-gray-50 border rounded-2xl p-6'>

                                <p className='text-sm text-gray-500'>
                                    Amount Paid
                                </p>

                                <h3 className='text-3xl font-bold text-gray-800 mt-2'>
                                    ₹ {booking?.price}
                                </h3>

                            </div>

                        </div>

                        {/* BOOKING DETAILS */}
                        <div className='mt-10 border rounded-3xl p-8'>

                            <h3 className='text-2xl font-bold text-gray-800 mb-6'>
                                Booking Details
                            </h3>

                            <div className='grid grid-cols-1 md:grid-cols-2 gap-6'>

                                <div>
                                    <p className='text-sm text-gray-500'>Customer Name</p>

                                    <h4 className='font-semibold text-lg mt-1'>
                                        {booking?.name}
                                    </h4>
                                </div>

                                <div>
                                    <p className='text-sm text-gray-500'>Mobile Number</p>

                                    <h4 className='font-semibold text-lg mt-1'>
                                        {booking?.mobile}
                                    </h4>
                                </div>

                                <div>
                                    <p className='text-sm text-gray-500'>Mandap</p>

                                    <h4 className='font-semibold text-lg mt-1'>
                                        {booking?.mandap?.name}
                                    </h4>
                                </div>

                                <div>
                                    <p className='text-sm text-gray-500'>Purpose</p>

                                    <h4 className='font-semibold text-lg mt-1'>
                                        {
                                            booking?.purpose_other ||
                                            booking?.purpose?.name ||
                                            '-'
                                        }
                                    </h4>
                                </div>

                                <div>
                                    <p className='text-sm text-gray-500'>From Date</p>

                                    <h4 className='font-semibold text-lg mt-1'>
                                        {formatDate(booking?.from_date)}
                                    </h4>
                                </div>

                                <div>
                                    <p className='text-sm text-gray-500'>To Date</p>

                                    <h4 className='font-semibold text-lg mt-1'>
                                        {formatDate(booking?.to_date)}
                                    </h4>
                                </div>

                            </div>

                        </div>

                        {/* INFO */}
                        <div className='mt-8 bg-blue-50 border border-blue-100 rounded-2xl p-6'>

                            <h3 className='text-lg font-semibold text-blue-800'>
                                Important Information
                            </h3>

                            <ul className='mt-4 space-y-2 text-sm text-blue-700'>

                                <li>
                                    • Your booking is currently pending admin approval.
                                </li>

                                <li>
                                    • You will receive confirmation after approval.
                                </li>

                                <li>
                                    • Please save your booking reference number.
                                </li>

                            </ul>

                        </div>

                        {/* BUTTONS */}
                        <div className='mt-10 flex flex-wrap gap-4'>

                            <button
                                onClick={() => navigate('/')}
                                className='bg-gray-900 hover:bg-black text-white px-8 py-4 rounded-2xl font-semibold transition-all shadow-lg'
                            >
                                Back To Home
                            </button>

                            <button
                                onClick={printReceipt}
                                className='bg-green-600 hover:bg-green-700 text-white px-8 py-4 rounded-2xl font-semibold transition-all shadow-lg'
                            >
                                Print Receipt
                            </button>

                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
}

export default BookingStatus;